import axiosInstance from './axios.service';

const BASE_URI = '/api/mercadopago';

class MercadoPagoService {
  /** Public site/currency/webhook config from backend */
  async getConfig() {
    const { data } = await axiosInstance.get(`${BASE_URI}/config`);
    return data;
  }

  /**
   * Creates a MercadoPago preference for a reservation.
   * @param {string} reservaId
   * @param {string} baseUrl
   * @param {string} paymentMethodId
   */
  async createPreference(reservaId, baseUrl, paymentMethodId) {
    const { data } = await axiosInstance.post(`${BASE_URI}/preference`, {
      reservaId,
      baseUrl,
      paymentMethodId,
    });
    return data;
  }

  /**
   * Saves a pending transaction record in the DB.
   */
  async createTransaction(reservaId, preferenceId, paymentMethodId, pricing) {
    const { data } = await axiosInstance.post(`${BASE_URI}/transaction`, {
      reservaId,
      preference: preferenceId,
      paymentMethodId,
      pricing,
      collection_status: 'pending',
    });
    return data;
  }

  async updateTransaction(preferenceId, payload) {
    const { data } = await axiosInstance.put(`${BASE_URI}/transaction/${preferenceId}`, payload);
    return data;
  }

  async verifyAndConfirm(paymentId, reservaId) {
    const { data } = await axiosInstance.post(`${BASE_URI}/verify-and-confirm`, {
      paymentId,
      reservaId,
    });
    return data;
  }

  async getWebhookConfig() {
    const { data } = await axiosInstance.get(`${BASE_URI}/webhookConfig`);
    return data;
  }

  async setWebhookConfig(enabled) {
    const { data } = await axiosInstance.put(`${BASE_URI}/webhookConfig`, { enabled });
    return data;
  }

  async getWebhookSecret() {
    const { data } = await axiosInstance.get(`${BASE_URI}/webhookSecret`);
    return data;
  }

  async setWebhookSecret(mercadoPagoWebhookSecret) {
    const { data } = await axiosInstance.put(`${BASE_URI}/webhookSecret`, {
      mercadoPagoWebhookSecret,
    });
    return data;
  }

  /** Admin: fetch current access token metadata */
  async getAccessToken() {
    const { data } = await axiosInstance.get(`${BASE_URI}/accessToken`);
    if (typeof data === 'string') {
      return { token: data, isTestMode: data.startsWith('TEST-'), site: 'UY' };
    }
    return data;
  }

  async setAccessToken(mercadoPagoAppKey) {
    const { data } = await axiosInstance.put(`${BASE_URI}/accessToken`, { mercadoPagoAppKey });
    return data;
  }
}

export default new MercadoPagoService();
